<template>
	<layout-main-form class="app-admin admin-watch-form" :action="action">
		<span slot="header">Watch</span>
		<spinner v-if="loading"/>
		<error-box v-else-if="error" :error="error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-text v-model="model.uid" name="watch_imei" placeholder="IMEI" rules="required"/>
			<error-box v-if="form_error" :error="form_error"/>
			<button type="submit" class="btn btn-primary">Save</button>
		</form>
	</layout-main-form>
</template>

<script>
export default {
	props: [
		'watch_id',
		'data',
		'action'
	],
	data () {
		return {
			loading: false,
			error: null,
			form_error: null,
			model: {
				uid: ''
			}
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			switch (this.action) {
				case 'add':
					this.addWatch()
					break
				case 'edit':
					this.editWatch()
					break
				default:
					this.$log.warn('admin', 'action not set')()
			}
		},
		getWatch () {
			this.loading = true
			this.$api.watches.admin.get(this, this.watch_id).then(response => {
				this.$log.info('admin', 'watches.admin.get OK', response)()
				this.model = response.body
			}).catch(errors => {
				this.$log.error('admin', 'watches.admin.get ERROR', errors)()
				this.error = errors
			}).finally(() => {
				this.loading = false
			})
		},
		addWatch () {
			this.$api.watches.admin.add(this, this.model).then(response => {
				this.$log.info('admin', 'watches.admin.add OK', response)()
				this.$router.push({ name: 'AdminWatchList' })
			}).catch(errors => {
				this.$log.error('admin', 'watches.admin.add ERROR', errors)()
				this.form_error = errors
			})
		},
		editWatch () {
			this.$api.watches.admin.edit(this, this.model).then(response => {
				this.$log.info('admin', 'watches.admin.edit OK')()
				this.$router.push({ name: 'AdminWatchList' })
			}).catch(errors => {
				this.$log.error('admin', 'watches.admin.edit ERROR', errors)()
				this.form_error = errors
			})
		}
	},
	beforeCreate () {
		this.$title('Watch Form')
	},
	mounted () {
		if (this.action === 'edit') {
			if (this.data === undefined) {
				this.getWatch()
			} else {
				this.model = this.data
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/watches/WatchForm.vue